import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AUTH_SERVICE } from '@app/auth/auth.token';
import { IAuthService } from '@app/auth/interfaces/auth-service.interface';
import { LanguageService } from '@avenir-client-web/language';
import { ProgressBarModule } from '@avenir-client-web/progress-bar';
import { ProgressSpinnerModule } from '@avenir-client-web/progress-spinner';
import { ToastModule } from '@avenir-client-web/toast';
import { CredentialsService } from '@core/authentication/credentials.service';
import { Credentials } from '@core/models/credentials.model';
import { SVG_ICON_SETS } from '@shared/constants/svg-icons.constants';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    ToastModule,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly compUnsubscribe$ = new Subject<void>();

  constructor(
    @Inject(AUTH_SERVICE) private readonly authService: IAuthService,
    private readonly credentialsService: CredentialsService,
    private readonly languageService: LanguageService,
    private readonly iconReg: SvgIconRegistryService
  ) {
    this.authService.init();
    this.registerSvgIcon();
  }

  ngOnInit(): void {
    this.handleLanguageRedirect();
  }

  ngOnDestroy(): void {
    this.compUnsubscribe$.next();
    this.compUnsubscribe$.complete();
  }

  private registerSvgIcon(): void {
    SVG_ICON_SETS.forEach(set => {
      set.iconNames.forEach(iconName => {
        this.iconReg.loadSvg(
          `${origin}/${set.iconRoute}/${iconName}.svg`,
          iconName
        );
      });
    });
  }

  private handleLanguageRedirect(): void {
    this.credentialsService
      .credentialsChanges()
      .pipe(takeUntil(this.compUnsubscribe$))
      .subscribe((credentials: Credentials) => {
        if (!credentials?.preferredLanguage) {
          return;
        }

        const currentUrlLang = this.languageService.getLanguageFromUrl();

        if (currentUrlLang !== credentials.preferredLanguage) {
          this.languageService.switchLanguage(credentials.preferredLanguage);
        }
      });
  }
}
